module.exports = __webpack_public_path__ + "img/GBYTE-alt.7dd77cbd.svg";